<nb-card class="resp-dialog">
  <nb-card-header>
    <h4><nb-icon icon="people-outline"></nb-icon>Verantwortliche</h4>
    <p class="resp-dialog__subtitle">{{ courseName }}</p>
  </nb-card-header>

  <nb-card-body>
    <p class="resp-dialog__hint">
      Verantwortliche stehen für das Material dieses Kurses ein. Ohne benannte
      Person kann für ihn keine inhaltliche Verknüpfung bestätigt werden.
    </p>

    <div *ngIf="loading" class="resp-dialog__empty">Wird geladen …</div>

    <ng-container *ngIf="!loading">
      <p *ngIf="!responsibles.length" class="resp-dialog__empty">
        Noch niemand benannt.
      </p>

      <ul class="resp-list" *ngIf="responsibles.length">
        <li *ngFor="let r of responsibles" class="resp-list__row">
          <div class="resp-list__who">
            <span class="resp-list__name">{{ r.name || r.email || '—' }}</span>
            <span class="resp-list__source">{{ sourceLabel(r) }}</span>
          </div>
          <button
            *ngIf="mayAppoint"
            nbButton ghost size="tiny" status="danger"
            [disabled]="saving"
            nbTooltip="Verantwortung entziehen"
            (click)="remove(r)"
          >
            <nb-icon icon="trash-2-outline"></nb-icon>
          </button>
        </li>
      </ul>

      <ng-container *ngIf="mayAppoint">
        <div class="resp-add">
          <nb-select
            placeholder="Person wählen …"
            [(selected)]="selectedUserId"
            [disabled]="saving"
          >
            <nb-option *ngFor="let u of pickableUsers" [value]="u.id">
              {{ userLabel(u) }}
            </nb-option>
          </nb-select>
          <button
            nbButton status="primary" size="small"
            [disabled]="!selectedUserId || saving"
            (click)="add()"
          >
            Benennen
          </button>
        </div>

        <button
          nbButton ghost size="small" status="basic"
          class="resp-sync"
          [disabled]="saving"
          (click)="syncFromLms()"
        >
          <nb-icon icon="sync-outline"></nb-icon>
          Aus Moodle-Lehrrollen übernehmen
        </button>
      </ng-container>

      <p *ngIf="!mayAppoint" class="resp-dialog__empty">
        Nur Managerinnen, Admins und bereits Verantwortliche dürfen hier ändern.
      </p>
    </ng-container>
  </nb-card-body>

  <nb-card-footer>
    <button type="button" nbButton status="primary" (click)="dialogRef.close(changed)">
      {{ 'buttons.close' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
